import React from 'react'

import FieldLabel from '@react/react-spectrum/FieldLabel'
import Textfield from '@react/react-spectrum/Textfield'
import Select from '@react/react-spectrum/Select'
import Switch from '@react/react-spectrum/Switch'

import MediaUpload from 'components/MediaUpload'
import { RichTextFormField } from 'components/RichTextEditor'
import { ScreenPicker } from '../../ScreenPicker'

const HeroBanner = ({ screen, project, projectConfig, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='Summary'>
        <RichTextFormField
          label='Page Summary'
          value={content.subtitle || ''}
          onChange={onChange('subtitle')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Heading'>
        <Textfield
          placeholder='Heading'
          name='heading'
          value={content.heading || ''}
          onChange={onChange('heading')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Hero Description'>
        <Textfield
          placeholder='Description'
          name='heroDescription'
          value={content.heroDescription || ''}
          onChange={onChange('heroDescription')}
          disabled={disabled}
          multiLine
        />
      </FieldLabel>

      <FieldLabel label='Banner Text Position'>
        <Select
          aria-label='Banner Text Position'
          options={projectConfig.bannerPositionOptions}
          placeholder={'Select an option'}
          name='bannerTextPosition'
          value={content.bannerTextPosition || ''}
          onChange={onChange('bannerTextPosition')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Hero Image' labelFor='heroImage'>
        <Switch
          label='Full width'
          checked={!!content.isFullWidthBanner}
          onChange={(v) => !disabled && onChange('isFullWidthBanner')(v)}
        />
        <MediaUpload
          type='image'
          value={content.heroImage || ''}
          maxHeight='100px'
          onUpload={onChange('heroImage')}
          projectId={project?.meta?.id}
          path={`hero-${screen?.meta?.name}-heroImage`}
          withTextfield={true}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Button Label'>
        <Textfield
          placeholder='Button Label'
          name='buttonLabel'
          value={content.buttonLabel || ''}
          onChange={onChange('buttonLabel')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Button Link'>
        <ScreenPicker
          screenName={screen?.meta?.name}
          value={content.buttonLink}
          onChange={onChange('buttonLink')}
          disabled={disabled}
        />
      </FieldLabel>
    </>
  )
}

const ChildScreens = ({ screen, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='Category Section Title' labelFor='categoriesSectionTitle'>
        <Textfield
          placeholder='Category Section Title'
          name='categoriesSectionTitle'
          value={content.categoriesSectionTitle || ''}
          onChange={onChange('categoriesSectionTitle')}
          disabld={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Category Title' labelFor='categoryTitle'>
        <Textfield
          placeholder='Category Title'
          name='categoryTitle'
          value={content.categoryTitle || ''}
          onChange={onChange('categoryTitle')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Category Link Label' labelFor='categoryLinkText'>
        <Textfield
          placeholder='Category Link Label'
          name='categoryLinkText'
          value={content.categoryLinkText || ''}
          onChange={onChange('categoryLinkText')}
          disabled={disabled}
        />
      </FieldLabel>

      <ScreenPicker
        screenName={screen?.meta?.name}
        screens={content.list}
        onChange={onChange('list')}
        disabled={disabled}
        multiple
      />
    </>
  )
}

export default [
  { label: 'Hero Banner', content: HeroBanner },
  { label: 'Child Screens', content: ChildScreens },
]
